export const isValidPageId = (pageId: string) =>
    new Set<PageId>([
        'photos_trending_page',
        'photos_newest_page',
        'photos_trending_landing_page',
        'photos_newest_landing_page',
        'photos_search_page',
        'creator_profile_page',
        'photo_related_page',
        'photo_random_page',
    ]).has(pageId as PageId);

const pageKeys: Record<PageId, (keyof PageData)[]> = {
    photos_search_page: ['page', 'page_number', 'tag'],
    creator_profile_page: ['page', 'page_number', 'id'],
    photos_trending_page: ['page', 'page_number'],
    photos_newest_page: ['page', 'page_number'],
    photos_newest_landing_page: ['page', 'page_number'],
    photos_trending_landing_page: ['page', 'page_number'],
    photo_related_page: ['page'],
    photo_random_page: ['page'],
};

export const assemblePhotoUrl = (
    photoBaseUrl: string,
    pageId: keyof typeof pageKeys,
    nextPhotoValues: PageData
): string => {
    const keys = pageKeys[pageId];
    let assembledURL = new URL(photoBaseUrl, window.location.origin);

    for (const key of keys) {
        const value = nextPhotoValues[key];
        if (!value) {
            break;
        } else {
            assembledURL.searchParams.append(key, value.toString());
        }
    }
    return `${assembledURL.pathname}${assembledURL.search}`;
};

export const NEXT_PHOTO_VALUES = 'next_photo_values';

export const getNextPhotoValues = (): PageData | null => {
    const nextPhotoValues = localStorage.getItem(NEXT_PHOTO_VALUES);
    if (!nextPhotoValues) {
        return null;
    }

    return JSON.parse(localStorage.getItem(NEXT_PHOTO_VALUES));
};

export const storeNextPhotoValues = (values: PageData) => {
    localStorage.setItem(NEXT_PHOTO_VALUES, JSON.stringify(values));
};
